import { ref, inject, type Ref } from 'vue'

type CurrentPage = {
  url: string
}

/**
 * Composable to manage page popup state and handle link clicks
 */
export const useAsyncPagePopup = <P extends CurrentPage>(pages: P[]) => {
  const isPagePopupOpen = ref(false)
  const currentPage = ref<P | null>(null)
  const openedPageIndex = ref<number>(0)
  const openAsyncPagePopupIds = inject<Ref<string[]>>('openAsyncPagePopupIds')

  const onPageLinkClick = (event: MouseEvent, page: P, _pages?: P[]) => {
    // To support nested page popups, we need to check if there are already open page popups
    // If there are, we don't open a new one and don't prevent the default action, resulting in opening the page url as normal
    if (openAsyncPagePopupIds?.value.length) {
      return
    }

    event.preventDefault()

    currentPage.value = page
    isPagePopupOpen.value = true
    openedPageIndex.value = (_pages ?? pages).findIndex(p => p.url === page.url)
  }

  return {
    isPagePopupOpen,
    currentPage,
    openedPageIndex,
    onPageLinkClick,
  }
}

